import { Container, Title, Body, LinkButton } from './FeedbackFooterSection.styles';

interface Props {
  className?: string;
}

export const FeedbackFooterSection = ({ className }: Props) => (
  <Container className={className}>
    <Title>Help us improve your experience</Title>
    <Body>This will only take 1-2 minutes.</Body>
    <LinkButton to="https://surveys.hotjar.com/s?siteId=30103&surveyId=124338" target="_blank">
      Give feedback
    </LinkButton>
  </Container>
);
